export default "__VITE_ASSET__EqCY0Jb8__"